<div class="client-widget">

        <div *ngIf="true">

            <div class="widget-header">Today's Mortgage Rates</div>
            <div>{{ rateDate | date: 'MMMM dd, yyyy' }}</div>
            <div class="widget-spacing"></div>

            <lgv-loading-indicator *ngIf="isLoading$ | async" [CSSClass]="'Small'"></lgv-loading-indicator>

            <swiper-container slides-per-view="1" space-between="15px" pagination="true" navigation="false"  pagination-clickable="true" speed="800" autoplay-delay="10000"
                        (swiperslidechangetransitionstart)="onSlideChangeEnd($event)" (swiperslidechange)="onSlideChangeStart($event)">
                <swiper-slide *ngFor="let product of productsWithAvgRates$ | async | keyvalue; let i = index">

                    <div class="swiper-content row">

                        <!-- Realfinity Rates -->
                        <div class="col-12 col-sm-6">
                            <div class="parent-div">
                                <div class="child-div">
                                    <div class="wrapper-box todays-rate">
                                        <div class="row g-0" *ngIf="!(isLoading$ | async) && product.value.todaysRate">
                                            <div class="col-6">
                                                <div class="valueSet-wrapper">
                                                    <div class="valueSet">
                                                        <div class="widget-standout-label value">
                                                            <strong>{{ product.value.todaysRate.rate | number: '1.2-2' }}%</strong>
                                                        </div>
                                                        <div class="label">Rate</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="valueSet-wrapper">
                                                    <div class="valueSet">
                                                        <div class="widget-standout-label value">
                                                            <strong>{{ product.value.todaysRate.apr | number: '1.2-2' }}%</strong>
                                                        </div>
                                                        <div class="label">APR</div>
                                                    </div>
                                                </div>

                                            </div>
        
                                        </div>

                                        <div class="row g-0" *ngIf="!(isLoading$ | async) && !product.value.todaysRate">
                                            <div class="col-12 text-center">
                                                <div class="valueSet-wrapper">
                                                    <div class="valueSet">
                                                        <div class="widget-standout-label value">
                                                            <strong>Not Available</strong>
                                                        </div>
                                                        <div class="label">Rate not available for this product</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="rate-header"
                                            (click)="showInfoModal('realfinityRate', { 
                                                rateDate: rateDate.toLocaleString(), 
                                                creditScore: product.value.todaysRate?.model?.loanInformation?.representativeFICO || 'N/A', 
                                                loanAmount: product.value.todaysRate?.model?.loanInformation?.baseLoanAmount?.toLocaleString() || 'N/A', 
                                                ltv: product.value.todaysRate?.model?.loanInformation?.baseLoanAmount && product.value.todaysRate?.model?.propertyInformation?.appraisedValue ? 
                                                    ((product.value.todaysRate.model.loanInformation.baseLoanAmount / product.value.todaysRate.model.propertyInformation.appraisedValue) * 100).toFixed(2) : 'N/A',
                                                averagePrice: product.value.todaysRate?.price ? formatPoints(product.value.todaysRate.price) : 'N/A'
                                            })">
                                            Realfinity's Rate <fa-icon icon="info-circle" class="info"></fa-icon>
                                        </div>
                                        <div class="rate-subheader"></div>
    

                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- National Average -->
                        <div class="col-12 col-sm-6">
                            <div class="parent-div">
                                <div class="child-div">
                                    <div class="wrapper-box avg-rate">
                                        <div class="row g-0" *ngIf="!(isLoading$ | async) && product.value.averageRate">
                                            <div class="col-6">
                                                <div class="valueSet-wrapper">
                                                    <div class="valueSet">
                                                        <div class="widget-standout-label value">
                                                            <strong>{{ product.value.averageRate?.averageRateToday | number: '1.2-2' }}%</strong>
                                                        </div>
                                                        <div class="label">Rate</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="valueSet-wrapper">
                                                    <div class="valueSet">
                                                        <div class="widget-standout-label value" [ngClass]="{
                                                                                    'rate-up': product.value.averageRate?.lastCloseDelta > 0,
                                                                                    'rate-down': product.value.averageRate?.lastCloseDelta < 0,
                                                                                    'no-change': product.value.averageRate?.lastCloseDelta == 0
                                                                                        }">
                                                            <fa-icon *ngIf="product.value.averageRate?.lastCloseDelta > 0" [icon]="farArrowUpLong" class="icon"></fa-icon>
                                                            <fa-icon *ngIf="product.value.averageRate?.lastCloseDelta < 0" [icon]="farArrowDownLong" class="icon"></fa-icon>
                                                            {{product.value.averageRate?.lastCloseDelta < 0 ?
                                                                roundOff(-product.value.averageRate.lastCloseDelta) : roundOff(product.value.averageRate?.lastCloseDelta || 0)
                                                                }}% </div>
                                                            <div class="label">Daily Change</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="rate-header" (click)="showInfoModal('nationalAverage', { 
                                                timestamp: product.value.averageRate?.timestamp?.toLocaleString() || 'N/A',
                                                averagePrice: product.value.averageRate?.averagePrice ? formatPoints(product.value.averageRate.averagePrice) : 'N/A'
                                            })">
                                            National Avg
                                            <fa-icon icon="info-circle" class="info"></fa-icon>
                                            </div>
                                            <div class="rate-subheader">
                                                Powered by Optimal Blue
                                            </div>
    
                                    </div>


                                    </div>
                                </div>
                        
                            </div>
                    </div>

                    <div class="product-name" [ngClass]="{ 'fade-in': isActiveSlide(i), 'fade-out': !isActiveSlide(i) }">{{ product.key.replace(' CONFORMING', '') }}</div>
                    <div class="Vert-15"></div>

                </swiper-slide>
            </swiper-container>

            <button class="btn btn-secondary" *ngIf="(lgvUserSvc.IsDLR || lgvUserSvc.IsCK ) && !(authMgrSvc.IsClient$ | async)" (click)="goToPricing()">Go to Pricing</button>

        </div>
</div>